import { useMemo } from 'react';
import {
  AgxBodyText,
  AgxIconCircularGreenTick,
  AgxProgressIndicator,
} from '@urbanx/agx-ui-components';
import { CampaignLaunchProgressModel } from '@urbanx/agx.campaigns.client';
import './LaunchDetailsProgress.scss';
import { AgxColumn, AgxRow } from '@urbanx/agx.ui-components2';

interface LaunchDetailsProgressProps {
  launchDetailsProgress?: CampaignLaunchProgressModel | undefined;
}

const renderProgress = (text: string, isComplete?: boolean) => (
  <AgxRow fill gap='ml' padding={{top: 'lg', bottom: 'lg'}} id="launchProgress">
    <AgxBodyText
      small
      extraClasses="launchProgressText"
      dataTestId={`launch-progress-${text.toLowerCase().replace(' ', '-')}`}
    >
      {text}
    </AgxBodyText>
    <AgxBodyText
      dataTestId={`launch-progress-${text.toLowerCase().replace(' ', '-')}-status`}
      small
      extraClasses={`launchProgressValue ${isComplete ? 'complete' : 'pending'}`}
    >
      {isComplete ? 'complete' : 'pending'}
    </AgxBodyText>
  </AgxRow>
);

const LaunchDetailsProgress = ({
  launchDetailsProgress,
}: LaunchDetailsProgressProps) => {
  const completedSteps = useMemo(
    () =>
      [
        launchDetailsProgress?.photosComplete,
        launchDetailsProgress?.floorplanComplete,
        launchDetailsProgress?.copywriteComplete,
        launchDetailsProgress?.videoComplete,
        launchDetailsProgress?.virtualTourComplete,
      ].filter(step => step).length,
    [launchDetailsProgress]
  );

  return (
    <AgxColumn gap='lg' padding={{top: 'xl', bottom: 'xl'}} justifyContent='center' alignItems='alignCenter' id="launchProgressPreparation">
      <>
        <AgxProgressIndicator
          currentSteps={completedSteps}
          totalSteps={5}
          width={60}
          height={60}
        />
        <AgxBodyText medium centered dataTestId="launch-preparation-in-progress">
          Launch preparation in progress
        </AgxBodyText>
        {
          <AgxColumn gap='none' fill id="launchProgressPreparationBody">
            {renderProgress(
              'Photos',
              launchDetailsProgress?.photosComplete
            )}
            {renderProgress(
              'Floor Plan',
              launchDetailsProgress?.floorplanComplete
            )}
            {renderProgress(
              'Copywrite',
              launchDetailsProgress?.copywriteComplete
            )}
            {renderProgress(
              'Video',
              launchDetailsProgress?.videoComplete
            )}
            {renderProgress(
              'Virtual Tour',
              launchDetailsProgress?.virtualTourComplete
            )}
          </AgxColumn>
        }
      </>
    </AgxColumn>
  );
};

export default LaunchDetailsProgress;
